import { academicYear as AcademicYearService } from '@coligo-org/fe-common/services';
import Types from '../types';
import logger from '../../../../../../../common/services/logService';
import { ErrorsActions } from '../../../../../common/error/state';

export const createItemStart = () => ({
  type: Types.CREATE_ITEM_START,
});

export const createItemEnd = () => ({
  type: Types.CREATE_ITEM_END,
});

export default ({ academicYearId, data, callback }) =>
  async dispatch => {
    try {
      dispatch(createItemStart());
      await AcademicYearService.createItem({ academicYearId, data });
      if (callback) callback();
    } catch (error) {
      logger.log(error);
      if (error.response) {
        dispatch(ErrorsActions.addError(error.response.data.message));
      }
    } finally {
      dispatch(createItemEnd());
    }
  };
